import React, { Component} from "react";
import { Switch, Route, withRouter } from "react-router-dom";
import MainPage from "./mainPage";
import StepByStepLists from "./stepByStepLists";
import SidebarPage from "./sidebarPage";
import FaqPage from "./faqPage";
import FaqListPage from "./faqListPage";
import AboutUs from "./aboutUs";
import ContactUs from "./contactUs";
import {MetaTags} from 'react-meta-tags';

class Layout extends Component {
	constructor(props) {
		super(props);
		this.state = {
			foo: props.location,
			stepByStepPageParam: {
				topSectionImageClassName: "", //"stepByStepTopSectionImage",
				componentName: "stepByStep",
				bannerName: "stepByStepBanner",
				lastSectionImageClassName: "stepByStepLastSectionImage"
			},
			quickStartPageParam: {
				topSectionImageClassName: "", //"quickStartTopSectionImage",
				componentName: "quickStart",
				bannerName: "quickStartBanner",
				lastSectionImageClassName: "quickStartLastSectionImage"
			}
		}
	}
	render () {
		return(
			<div>
				<MetaTags>
					<title>راهنمای مپسا-نرم افزار رایگان مدیریت پروژه های ساختمانی و حسابداری پروژه</title>
					<meta charSet="utf-8" />
					<meta name="description" content="-	مپسا نرم افزار رایگان مدیریت پروژه های ساختمانی و حسابداری پروژه می باشد. با مپسا علاوه بر مدیریت پروژه های ساختمانی و عمرانی می توانید حسابداری و تنخواه داری پروژه را نیز انجام دهید و صورت وضعیت پروژه را تهیه و از آن خروجی pdf و اکسل بگیرید."/>
					<meta name="keywords" content="ساختمان-ساخت و ساز-پاسخگوی سوالات شما در مورد ساختمان-پرداخت نقدی-پرداخت با چک-تنخواه گردان-مصالح ساختمانی"/>
					<meta name="author" content="شرکت مپسا"/>
					<meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no"/>
				</MetaTags>
				<Switch>
					<Route exact path='/' render={ () => ( <MainPage param={this.state.stepByStepPageParam} /> ) } />
					<Route exact path='/صفحه-اصلی' render={ () => ( <MainPage param={this.state.stepByStepPageParam} /> ) } />
					<Route exact path='/step-by-step' render={ () => ( <MainPage param={this.state.stepByStepPageParam} /> ) } />
					<Route exact path='/quick-start' render={ () => ( <MainPage param={this.state.quickStartPageParam} /> ) } />

					<Route exact path='/payment-and-purchase' render={ () => ( <StepByStepLists /> ) } />
					<Route exact path='/receive' render={ () => ( <StepByStepLists /> ) } />
					<Route exact path='/reports' render={ () => ( <StepByStepLists /> ) } />
					<Route exact path='/calender' render={ () => ( <StepByStepLists /> ) } />
					<Route exact path='/functions' render={ () => ( <StepByStepLists /> ) } />
					<Route exact path='/setting' render={ () => ( <StepByStepLists /> ) } />

					<Route exact strict={true} path={`/step-by-step/:name/:title/:id`} render={ () => ( <SidebarPage /> ) } />
					<Route exact strict={true} path={`/faq/:id`} render={ () => ( <FaqPage /> ) } />
					<Route exact strict={true} path={`/faq`} render={ () => ( <FaqListPage /> ) } />
					<Route exact strict={true} path={`/articles`} render={ () => ( null ) } />
					<Route exact strict={true} path={`/aboutus`} render={ () => ( <AboutUs /> ) } />
					<Route exact strict={true} path={`/contactus`} render={ () => ( <ContactUs /> ) } />
				</Switch>
			</div>
		);
	}
}

export default withRouter(Layout);